import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { FormikForm } from "components/FormikForm/FormikForm";
import { FormikValues } from "formik";
import { useToast } from "hooks/useToast";
import { useUpdateGroupNameMutation } from "store/apis/group";
import { BackendError } from "types/utils/error";
import { ModalProps } from "types/utils/modal";
import { object, string } from "yup";

export const EditGroupName = ({
  isOpen,
  close,
  groupName,
  groupId,
}: ModalProps & {
  groupName: string;
  groupId: string;
}) => {
  const { alertToast, successToast } = useToast();
  const [updateGroup, { isLoading }] = useUpdateGroupNameMutation();

  const onSubmit = async (values: FormikValues) => {
    try {
      await updateGroup({
        groupId,
        name: values.name,
      }).unwrap();
      successToast({ message: "Group name updated successfully" });
      close();
    } catch (error) {
      alertToast({ message: (error as BackendError)?.data?.error?.message });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content asChild>
        <FormikForm
          initialValues={{
            name: groupName || "",
          }}
          validationSchema={object({
            name: string().required("Name is required"),
          })}
          validateOnChange
          onSubmit={onSubmit}
        >
          {({ submitForm, dirty }) => (
            <>
              <Modal.Header>
                <Modal.Title>Edit Brand Name</Modal.Title>
                <Modal.Close />
              </Modal.Header>
              <Modal.Body>
                <TextInput
                  name="name"
                  required
                  label="Name"
                  placeholder="Brand name"
                  note="Name change will update the brand name across the platform
                      and affect all records created going forward."
                  customType="warning"
                />
              </Modal.Body>
              <Modal.FooterButtonGroup>
                <Modal.RawClose asChild>
                  <Button>Cancel</Button>
                </Modal.RawClose>
                <Button
                  disabled={!dirty || isLoading}
                  isLoading={isLoading}
                  onClick={submitForm}
                  customType="primary"
                >
                  Save
                </Button>
              </Modal.FooterButtonGroup>
            </>
          )}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
